import Vue from 'vue';
import Vuex, {MutationTree} from 'vuex';
import {Content} from '@/api';

Vue.use(Vuex);

interface State {
  content: Content | null;
  imgURL: string;
}
const state: State = {
    content: null,
    imgURL: '',
};

const mutations: MutationTree<State> = {
    setBook: (s, book: Content) => (s.content = book),
    setImgURL: (s, imgURL: string) => (s.imgURL = imgURL),
};

const actions = {
    setBook(context: any, book: Content) {
        context.commit('setBook', book);
    },
    setImgURL(context: any, imgURL: string) {
        context.commit('setImgURL', imgURL);
    },
};

const getters = {
    getBook(s: State): Content | null {
        return s.content;
    },
    getImgURL(s: State): string {
        return s.imgURL;
    },
};

export default new Vuex.Store<State>({
    state,
    mutations,
    actions,
    getters,
});
